import { useEffect } from 'react';

import { StackLayout } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { MainPageContainer } from '@leagueplatform/web-common-components';
import { PremiumPaymentHistoryMasonrySection } from 'components/premium-payment/premium-pyament-history-masonry-section.component';
import { HeroSection } from 'components/hero-section/hero-section.component';
import { sendPremiumPaymentHistoryScreenLoadedEvent } from 'utils/analytics-events';
import { useGoBack } from 'hooks/use-go-back.hook';

const PremiumPaymentHistoryPage = () => {
  const { formatMessage } = useIntl();
  const { handleGoBack } = useGoBack();
  const title = formatMessage({ id: 'STR_PREMIUM_PAYMENT_HISTORY' });

  useEffect(() => {
    sendPremiumPaymentHistoryScreenLoadedEvent();
  }, []);

  return (
    <MainPageContainer
      width="100%"
      css={{
        '.GDS-vertical-stack-layout': {
          width: '100%',
        },
        '.GDS-select': {
          maxWidth: '267px',
        },
        "[data-testid*='emptyState']": {
          textAlign: 'center',
        },
      }}
    >
      <HeroSection title={title} height="120px" goBack={handleGoBack} />
      <StackLayout>
        <StackLayout
          css={{
            marginBottom: '$four',
          }}
        >
          <PremiumPaymentHistoryMasonrySection />
        </StackLayout>
      </StackLayout>
    </MainPageContainer>
  );
};

export default PremiumPaymentHistoryPage;
